module.exports = __webpack_public_path__ + "img/plus-black.720d677d.svg";